var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{ref:"input",attrs:{"filled":"","persistent-hint":"","no-resize":"","counter":"","rows":_vm.rows + 1,"label":_vm.label,"disabled":_vm.disabled,"hint":_vm.hint,"value":_vm.value,"rules":_vm.rules},on:{"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }